import { type SelectProps, Select } from 'antd'
import { useTranslation } from 'react-i18next'

export const StatusSelect = (props: SelectProps) => {
  const { t } = useTranslation()

  const options: SelectProps['options'] = [
    {
      value: 'false',
      label: t('nomenclature.inactive'),
      searchLabel: t('nomenclature.inactive')
    },
    {
      value: 'true',
      label: t('nomenclature.active'),
      searchLabel: t('nomenclature.active')
    }
  ]

  return (
    <Select
      options={options}
      placeholder={t('select_from_list')}
      popupMatchSelectWidth
      className="select-min-width"
      allowClear
      {...props}
    />
  )
}
